export const secondToMillis = (time: number) => time * 1000
